import { openDB } from "idb";

export const dbPromise = async (dbName, dbVersion, storeName, keyPath) => {
  const db = openDB(dbName, dbVersion, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, {
          keyPath: keyPath,
          autoIncrement: true,
        });
      }
    },
  });
  return db;
};
